<template>
  <div class="">
    <!--<table>-->
    <!--<tr>-->
    <!--<td>-->
    <!--<span v-if="this.validEAN13">-->
    <!--<i class="fa fa-check"></i>-->
    <!--</span>-->
    <!--<span v-if="!this.validEAN13">-->
    <!--<i class="fa fa-times"></i>-->
    <!--</span>-->
    <!--</td>-->
    <!--<td><svg v-bind:id="'jsbarcodeEAN'+this.num"></svg></td>-->
    <!--<td>-->
    <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="print()" v-if="(this.hasprint)">-->
    <!--<i class="fa fa-dot-circle-o"></i> {{$t('BarcodeGenerator.printTitle')}}-->
    <!--</button>-->
    <!--</td>-->
    <!--</tr>-->
    <!--<tr>-->
    <!--<td>-->
    <!--<span v-if="this.validCODE128">-->
    <!--<i class="fa fa-check"></i>-->
    <!--</span>-->
    <!--<span v-if="!this.validCODE128">-->
    <!--<i class="fa fa-times"></i>-->
    <!--</span>-->
    <!--</td>-->
    <!--<td>-->
    <table>
      <tr>
        <td>

          <div v-bind:style="{'width':paperWidth}" class="barcodeContainer">
            <svg v-bind:id="'jsbarcode'+this.num"></svg>
            <div id="barcodeTextContainer" class="barcodeTextContainer text-center w100 "  v-bind:style="{'font-size':printFontSize+'px','line-height':printFontSize+'px', 'top': Number((printFontSize*0.1)+data.height+35)+'px'}">{{this.extratext}}</div>
          </div>
          <!--<div v-bind:style="{'width':paperWidth}" class="barcodeTextContainer">-->
            <!--<div class="text-center"  v-bind:style="{'font-size':printFontSize+'px'}">{{this.extratext}}</div>-->
          <!--</div>-->

        </td>
      </tr>
      <tr>
        <td>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="print()" v-if="(this.hasprint && this.visiblePrintButton)" style="margin-top:10px">
            <i class="fa fa-print"></i> {{$t('BarcodeGenerator.printTitle')}}
          </button>
          <button type="button" class="btn btn-secondary btn-sm" v-on:click="openInfo()" v-if="(this.hasprint && this.visiblePrintButton)" style="margin-top:10px;margin-left:10px;">
            <i class="fa fa-info-circle"></i> {{$t('BarcodeGenerator.openInfo')}} <i class="fa fa-caret-square-o-down"></i>
          </button>
        </td>
      </tr>
    </table>
    <div v-if="(this.showHideProps)" class="printerSettingsInfo printhide">{{$t('BarcodeGenerator.printerSettingsInfo')}}</div>
    <!--<span  v-if="(validCODE128)"><i class="fa fa-times fa-errordisplay"></i></span>-->
    <!--</td>-->
    <!--<td>-->

    <!--</td>-->
    <!--</tr>-->
    <!--</table>-->


    <!--<template v-if="(this.isprint)">-->
    <!--&lt;!&ndash;<BarcodeGeneratorCss/>&ndash;&gt;-->
    <!--</template>-->


  </div>
</template>

<script>
  import JsBarcode from 'jsbarcode';

  export default {
    name: 'BarcodeGenerator',
    data(){
      return {
        num: 0
        , visiblePrintButton: false
        , isprint: false
        , validEAN13: false
        , validCODE128: false
        , data: {
          width: 2,
          height: 40,
          format: "CODE128", // EAN13 a sör
          displayValue: true,
          fontOptions: "",
          font: "monospace",
          text: undefined,
          textAlign: "center",
          textPosition: "bottom",
          textMargin: 2,
          fontSize: 20,
          background: "#ffffff",
          lineColor: "#000000",
          margin: 10,
          marginTop: undefined,
          marginBottom: undefined,
          marginLeft: undefined,
          marginRight: undefined,
        }
        ,showHideProps:false

      }
    },
    mounted() {
      const modul = this;

      this.num = Math.ceil(Math.random() * 1000000);
      window.setTimeout(function () {
        modul.generate();
      }, 1000);
    },
    props: {
      type: String,
      barcode: String,
      paperWidth: String,
      extratext: String,
      printFontSize: Number,
      hasprint: Boolean,
    },
    watch: {
      barcode: function (newdata, olddata) {
        const modul = this;
        this.barcode = newdata;
        modul.generate();
        this.visiblePrintButton = !!newdata;
      },
      extratext: function (newdata, olddata) {
        const modul = this;
//        this.barcode = newdata;
        modul.generate();
//        this.visiblePrintButton = !!newdata;
        this.visiblePrintButton = !!modul.barcode;

      },
      printFontSize: function (newdata, olddata) {
        const modul = this;
        modul.generate();
        this.visiblePrintButton = !!modul.barcode;
      },
//      showHideProps: function (newdata, olddata) {
//        const modul = this;
//      },


    },
    methods: {
      generate(e)
      {
        const modul = this;
        if (document.querySelector('#jsbarcode' + this.num) !== null) {
          /*   let title="";
           if(Number(modul.printProductPrice)===1){
           title+=modul.extratext1;
           }
           if(Number(modul.printProductTitle)===1){
           title+=" | "+modul.extratext2;
           }
           if(title.length>0){
           title+=" | "+modul.barcode;
           }
           this.data.text=title;

           if( modul.printFontSize ){
           this.data.fontSize=modul.printFontSize;
           }*/


          console.log(document.querySelector('#jsbarcode' + this.num));
          let title = "";
//          if (modul.extratext) {
//            title += modul.extratext;
//          }
          if (title.length > 0) {
            title += " | " + modul.barcode;
          }
          this.data.text = title;
//          if (modul.printFontSize) {
//            this.data.fontSize = modul.printFontSize;
//          }

          if (this.barcode !== "") {
            JsBarcode('#jsbarcode' + modul.num, this.barcode, Object.assign({}, this.data));
          } else {
//              this.data.width=0;
//              this.data.displayValue=false;
            JsBarcode('#jsbarcode' + modul.num, 0, Object.assign({}, this.data, {width: 0, displayValue: true, height: 0}));
          }
          modul.visiblePrintButton = !!modul.barcode;
        }
      },

      openInfo()
      {

        console.log("showHidePropsPixels");
        if (this.showHideProps) {
          this.showHideProps = false;
        } else {
          this.showHideProps = true;
        }
      },

      print(e)
      {
        const modul = this;
        const element = document.getElementById('jsbarcode' + modul.num);
        const documenttitle = document.title;
        document.title = "Barcode"
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        element.classList.add("prt");
        const barcodeTextContainer=document.getElementById("barcodeTextContainer")
        barcodeTextContainer.classList.add("prt");
        const allElement = document.querySelectorAll('body .printhide,body .p, body label, body input, body button, body img, body i, body a, body h1, body h2, body h3, body h4, body h5, body select, body strong, body aside, body ul, body li, body .btn');
        allElement.forEach(function (e) {
          e.style.display = "none";
        });
        const allElementDivs = document.querySelectorAll('div:not(#barcodeTextContainer), header');
        allElementDivs.forEach(function (e) {
          e.style.cssText += "background-color: white  margin:0 !important; height:0 !important; width:0 !important; border:0 !important; margin: 0 !important; padding: 0 !important;";
        });
        modul.isprint = true;
        const body = document.querySelector('body');
        body.style.backgroundColor = 'white';

        window.print();

        modul.isprint = false;
        document.title = documenttitle;
        allElement.forEach(function (e) {
          e.style.removeProperty('display')
        });
        allElementDivs.forEach(function (e) {
          e.style.removeProperty("background-color");
          e.style.removeProperty("display");
          e.style.removeProperty("margin");
          e.style.removeProperty("height");
          e.style.removeProperty("width");
          e.style.removeProperty("border");
          e.style.removeProperty("margin");
          e.style.removeProperty("padding");
        });
        body.classList.remove('backgroundColor');
        element.classList.remove("prt");
        barcodeTextContainer.classList.remove("prt");
        if( window.pageYOffset ){
          window.pageYOffset =scrollTop
        } else {
          document.documentElement.scrollTop=scrollTop
        }

      },
    },
    components: {},

  };
</script>

<style>

  .prt {
    display: block;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 10;
  }

  .fa-errordisplay {
    font-size: 30px;
    color: #ee3333;
  }

  /**:not(svg) {*/
  /*display: none !important;*/
  /*margin: 0 !important;*/
  /*padding: 0 !important;*/
  /*max-width: 1px;*/
  /*max-height: 1px;*/
  /*font-size: 1px;*/
  /*}*/
  .barcodeContainer {
    color: black !important;
  }
  .printerSettingsInfo{
    border: 2px solid #888;
    margin-top: 10px;
    padding: 10px;

  }

</style>

<style >
  .barcodeContainer svg rect{
    border:1px solid black;

  }
</style>
